<template>
  <div class="usablility-card">
    <div class="usablility-card-title">{{ cardInfor.title }}</div>
    <div class="usablility-card-content">
      <div class="usablility-card-content-list">
        <div v-for="(item, index) in cardInfor.content" :key="index">
          {{ item }}
        </div>
      </div>
    </div>
   
    <div class="usablility-card-footer" v-if="cardInfor.url">
      <a :href="cardInfor.url" target="_blank">查看更多</a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    cardInfor: Object,
  }
};
</script>

<style lang="scss">
.usablility-card {
  background: #FFFFFF;
  border: 1px solid rgba(234,234,234,1);
  border-radius: 6px; 
  width: 370px;
  height: 164px;
  padding: 16px;
  .usablility-card-title {
    font-size: 16px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 700;
    border-left: 4px solid #E70012;
    padding-left: 8px;
  }
  .usablility-card-content {
    .usablility-card-content-list {
      margin: 12px 0;
      height: 66px;
      >div {
        font-size: 14px;
        color: #333333;
        letter-spacing: 0;
        line-height: 22px;
        font-weight: 400;
      }
    }
  }
  .usablility-card-footer {
    text-align: right;
    a {
      font-size: 12px;
      color: #1BA8FF;
      letter-spacing: 0;
      line-height: 21px;
      font-weight: 400;
      text-decoration: none;
    }
  }
  
}
</style>